
import React from 'react';
import ReactSelect from 'react-select';
import { Button, Modal,  ModalBody, ModalFooter, Col, Label, Row, Input, FormGroup } from 'reactstrap';
import ModalHeader from "@dhn/components/molecules/modal-header";

export default function ModalParametersMedical({ state, onChange, toggle }) {

  return (
    <div>
      <Modal isOpen={state.modalIsOpenParameters} toggle={toggle} centered size='xl'>
        <ModalHeader
          toggle={toggle}
          iconClass="fa-sliders"
          description="Agregar parámetro médico"
          subtitle="Complete el grupo, la unidad de medida y los valores del parámetro."
        />
        <ModalBody>
          <Row form>
            <Col md={3}>
              <Label>
                Grupo de Parámetros
              </Label>
              <Input placeholder='Grupo de Parámetros' />
            </Col>
            <Col md={3}>
              <Label>
                Parámetro Médico
              </Label>
              <Input placeholder='Parámetro Médico' />
            </Col>
            <Col md={3}>
              <Label>
                Unidad de Medida
              </Label>
              <Input placeholder='Unidad de Medida' />
            </Col>
          </Row>

          <Row className='my-4 d-flex align-items-end' form>
            <Col md={2}>
              <Label>
                Tipo de Parámetro
              </Label>
              <Input placeholder='Tipo de Parámetro' />
            </Col>
            <Col md={2}>
              <Label>
                Valor Optimo
              </Label>
              <FormGroup className='d-flex align-items-center mb-0'>
                <Label className='mx-2'>Mínimo:</Label>
                <Input placeholder='Mínimo' />
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup className='d-flex align-items-center mb-0'>
                <Label className='mr-2'>
                  Máximo:
                </Label>
                <Input placeholder='Máximo' />
              </FormGroup>
            </Col>
            <Col md={2}>
              <Label>
                Tipo de Parámetro:
              </Label>
              <Input placeholder='Tipo de Parámetro' />
            </Col>
            <Col md={3} className='ml-2'>
              <Label>
                {'Frecuencia:'}
              </Label>
              <ReactSelect
                placeholder='Seleccionar perfil'
                getOptionLabel={(item) => item.name}
                getOptionValue={(item) => item}
                // options={data?.profiles || []}
                value={null}
                onChange={v => {
                  console.log(v);

                }}
              />
            </Col>
          </Row>

        </ModalBody>
        <ModalFooter>
          <Button
            color='success'
            className='btn-color-success'
            onClick={toggle}>
            <i className="fa fa-plus" aria-hidden="true"></i>
            {" Agregar"}
          </Button>
          <Button color='danger'
            className='btn-color-danger'
            onClick={toggle}>
            <i className="fa fa-times" aria-hidden="true"></i>
            {" Cancelar"}
          </Button>
        </ModalFooter>
      </Modal>
    </div >
  );
}